import { render, staticRenderFns } from "./comment_input.vue?vue&type=template&id=61e30b5b&scoped=true&"
import script from "./comment_input.vue?vue&type=script&lang=js&"
export * from "./comment_input.vue?vue&type=script&lang=js&"
import style0 from "./comment_input.vue?vue&type=style&index=0&id=61e30b5b&scoped=true&lang=css&"
import style1 from "./comment_input.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e30b5b",
  null
  
)

export default component.exports